import { Chip } from '@/components/commons/chip'
import { ExpandImageButton } from '@/components/commons/expand-image-button'
import { ImageCard } from '@/components/commons/image-card'
import { Image01Icon, Stars01Icon } from '@/components/ui/icons'
import type { PhotosetSpace } from '@/features/photoset/types'
import { useTranslation } from '@/translations/i18n'
import { SpaceImagesContainer } from './space-images-atoms'

export const NeedsReviewSpaceImages = ({
	images,
	spaceIndex,
	onExpandImage
}: {
	images: PhotosetSpace['images']
	spaceIndex: number
	onExpandImage: (spaceIndex: number, imageIndex: number) => void
}) => {
	const { t } = useTranslation()

	return (
		<SpaceImagesContainer $gap={4}>
			{images.map((image, index) => {
				const thumbnails =
					image.retouched_thumbnails?.xs ||
					image.ai_retouched_thumbnails?.xs

				return (
					<ImageCard
						badgeType='to_revise'
						endSlot={
							<>
								<div className='flex flex-wrap gap-1.5'>
									{image.flags
										.filter(
											(flag) =>
												flag.type ===
												'visual_retouching'
										)
										.map((flag) => (
											<Chip
												isActive={true}
												key={flag.id}
												label={t(
													`photoset:flags.${flag.key_name}.label`
												)}
												variant={'info'}
											/>
										))}
								</div>
								<ExpandImageButton
									onClick={() =>
										onExpandImage(spaceIndex, index)
									}
								/>
							</>
						}
						hideCheckbox
						image={image}
						imageNameIcon={
							image.is_manually_retouched ? (
								<Image01Icon size={20} />
							) : (
								<Stars01Icon size={20} />
							)
						}
						isSelected={false}
						key={image.id}
						showBadge={image.needs_to_review}
						thumbnail={thumbnails}
					/>
				)
			})}
		</SpaceImagesContainer>
	)
}
